export default __webpack_public_path__ + "static/media/08.a6f8175f.jpg";